import detail from "./detail";

export default `
${detail}
`;
